import React from 'react';
import { motion } from 'framer-motion';

const voordelen = [
  {
    stat: '72u',
    title: 'Snelheid waarop u kunt rekenen',
    body: 'Vanaf ondertekende aanvraag tot vakman op locatie in 72 uur. Onze kandidatenpipeline in 12 EU-landen betekent geen wachttijd — profielen zijn voorgeselecteerd en klaar.',
  },
  {
    stat: '100%',
    title: 'Nul compliance-verrassingen',
    body: 'Elke plaatsing wordt geleverd met volledige Belgische sociale wetgeving: RSZ/ONSS, Dimona, A1-certificaten en grensoverschrijdende belasting. Ons juridisch team regelt elk document vóór dag één.',
  },
  {
    stat: 'x8',
    title: 'Acht sectoren, één partner',
    body: 'Van vrachtwagenchauffeur tot verpleegkundige tot software-engineer — één raamovereenkomst dekt uw volledige personeelsbehoefte. Één factuur, één contactpersoon, één compliance-garantie.',
  },
];

const BVMVoordeel = () => {
  return (
    <section id="voordeel" className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#0D0D0D', borderTop: '1px solid #1A1A1A' }}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full blur-[160px] opacity-4" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <motion.h2
              className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold leading-none"
              style={{ color: '#FFFFFF' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              HET<br /><span style={{ color: '#00E5A0' }}>VOORDEEL</span>
            </motion.h2>
          </div>
          <motion.p
            className="text-base leading-relaxed"
            style={{ color: '#888888' }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
          >
            Drie zaken onderscheiden BVM Group van elke andere EU-personeelsdienst in België. Geen beloftes — operationele realiteiten.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: '#1A1A1A' }}>
          {voordelen?.map((v, i) => (
            <motion.div
              key={i}
              className="p-8 md:p-10 group"
              style={{ background: '#0D0D0D' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              whileHover={{ background: '#111111' }}
            >
              <p
                className="text-5xl md:text-6xl font-heading font-bold mb-6 leading-none"
                style={{ color: '#00E5A0' }}
              >
                {v?.stat}
              </p>
              <h3 className="text-lg font-heading font-semibold text-white mb-4">{v?.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#777777' }}>{v?.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BVMVoordeel;
